import IMask from 'imask';

; (() => {
    const inputs = document.querySelectorAll('.js-imask-phone')

    Array.from(inputs).forEach(input => {
        IMask(input, {
            mask: '+00 000 000 000 000 000'
        })
    })
})()

    ; (() => {
        const inputs = document.querySelectorAll('.js-imask-phone-custom')

        Array.from(inputs).forEach(input => {
            const mask = input.dataset.mask
            if (!mask) return

            IMask(input, { mask })
        })
    })()

    ; (() => {
        const inputs = document.querySelectorAll('.js-imask-time')

        Array.from(inputs).forEach(input => {
            IMask(input, {
                mask: '00:00:00'
            })
        })
    })()
    ; (() => {
        const maskOptions = {
            overwrite: true,
            autofix: true,
            mask: 'HH:MM',
            blocks: {
                HH: {
                    mask: IMask.MaskedRange,
                    placeholderChar: 'HH',
                    from: 0,
                    to: 23,
                    maxLength: 2
                },
                MM: {
                    mask: IMask.MaskedRange,
                    placeholderChar: 'MM',
                    from: 0,
                    to: 59,
                    maxLength: 2
                }
            }
        }
        const inputs = document.querySelectorAll('.js-imask-hour-minutes')

        Array.from(inputs).forEach(input => {
            IMask(input, maskOptions)
        })
    })()

CNS.$fns.initImaskTel = function (selector) {
    const input = document.querySelector(selector)
    if (!input) return
    IMask(input, {
        mask: '+00 000 000 000 000 000'
    })
};

// ====================================================================
// IMASK custom
; (() => {
    const inputs = document.querySelectorAll('.js-imask-custom')

    Array.from(inputs).forEach(input => {
        console.log('input', input)
        const mask = input.dataset.mask

        IMask(input, { mask })
    })

    function initImaskCustom(selector) {
        const input = document.querySelector(selector)
        if (!input) return
        console.log('input', input)
        const mask = input.dataset.mask

        IMask(input, { mask })
    }

    CNS.$fns.initImaskCustom = initImaskCustom
})()

